// edit api url here 
const apiUrl = process.env.NODE_ENV === 'development' ? 'https://devurl' : 'https://productionurl'

const defaultTransition = {
    appear: 0, // animation-duration
    enter: 500, // enter-animation-duration
    exit: 0, // exist-animation-duration
  };

export { defaultTransition, apiUrl };